/* ============================================================
   ap-sticky-variant-bar.js
   Mini sticky variant bar — IntersectionObserver + variant sync
   Scope: producto apparelle_signature
   ============================================================ */
(function () {
  'use strict';

  // Guard: solo mobile y solo si elementos existen
  if (window.matchMedia && !window.matchMedia('(max-width: 749px)').matches) return;

  function init() {
    var bar = document.querySelector('[data-ap-sticky-variant-bar]');
    if (!bar) return;

    var variantsRaw = bar.getAttribute('data-variants');
    if (!variantsRaw) return;

    var variants;
    try {
      variants = JSON.parse(variantsRaw);
    } catch (e) {
      return;
    }

    var thumb = bar.querySelector('[data-sticky-thumb]');
    var nameEl = bar.querySelector('[data-sticky-name]');
    var priceEl = bar.querySelector('[data-sticky-price]');
    var priceCompareEl = bar.querySelector('[data-sticky-price-compare]');

    // Mapa color → variant data
    var byColor = {};
    variants.forEach(function (v) {
      var key = (v.color || '').toLowerCase();
      if (!byColor[key]) byColor[key] = v;
    });

    function updateBar(colorName) {
      if (!colorName) return;
      var v = byColor[(colorName || '').toLowerCase()];
      if (!v) return;
      if (thumb && v.image) {
        thumb.style.backgroundImage = "url('" + v.image + "')";
      }
      if (nameEl) nameEl.textContent = v.color || '';
      if (priceEl) priceEl.textContent = v.price || '';
      if (priceCompareEl) {
        if (v.compare_at_price && v.compare_at_price !== v.price) {
          priceCompareEl.textContent = v.compare_at_price;
          priceCompareEl.style.display = '';
        } else {
          priceCompareEl.style.display = 'none';
        }
      }
      // Pulse animation
      if (thumb) {
        thumb.classList.remove('is-pulse');
        // force reflow
        void thumb.offsetWidth;
        thumb.classList.add('is-pulse');
      }
    }

    // ====== Listener al cambio de variante ======
    // Horizon emite eventos variant:change. Usamos color-position desde data attribute
    var colorPos = parseInt(bar.getAttribute('data-color-position'), 10) || 1;
    document.addEventListener('variant:change', function (ev) {
      try {
        var v = ev && ev.detail && ev.detail.variant;
        if (!v) return;
        var colorVal = (colorPos === 2) ? v.option2 : (colorPos === 3 ? v.option3 : v.option1);
        if (colorVal) updateBar(colorVal);
      } catch (e) { /* swallow */ }
    });

    // Fallback: escucha clicks en swatches del variant_picker nativo
    var pickerScope = document.querySelector('.product-information, [data-product-info], main') || document;
    pickerScope.addEventListener('click', function (ev) {
      var target = ev.target.closest('input[name^="Color" i], label[for*="Color" i], [data-option-position="1"] input, .product-form__input--color input, swatch-input input');
      if (!target) return;
      // espera al próximo frame para que el theme actualice el state
      requestAnimationFrame(function () {
        var label = target.value || target.getAttribute('value') || target.dataset.value;
        if (label) updateBar(label);
      });
    });

    // ====== IntersectionObserver: mostrar/ocultar ======
    var gallerySelectors = [
      '[data-product-gallery]',
      '.product-gallery',
      'product-media-gallery',
      'media-gallery',
      '.product__media-list',
      '.product-information__media',
      'horizon-media'
    ];

    var galleryEl = null;
    for (var i = 0; i < gallerySelectors.length; i++) {
      galleryEl = document.querySelector(gallerySelectors[i]);
      if (galleryEl) break;
    }
    // último fallback: primer <img> grande en main del producto
    if (!galleryEl) {
      var firstImg = document.querySelector('main img');
      if (firstImg) galleryEl = firstImg.closest('div, section') || firstImg;
    }
    if (!galleryEl) return;

    if (!('IntersectionObserver' in window)) {
      // Browsers viejos: dejar siempre visible
      bar.classList.add('is-visible');
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('is-visible');
        } else {
          bar.classList.add('is-visible');
        }
      });
    }, { threshold: 0.15 });

    obs.observe(galleryEl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
